import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import HtmlParser from "react-html-parser";

const StackItem = [
  {
    icon: "01",
    title: "Optimized<br/> Performance",
    description:
      "Use efficient coding and performance optimization for a quick, friendly, and reliable website. Speed up operations and offer responsive browsing to users.",
  },
  {
    icon: "02",
    title: "Robust<br/> Security",
    description:
      "Integrate secure data handling, encryption, and continuous monitoring to protect websites and users against threats. Maintain 100% integrity.",
  },
  {
    icon: "03",
    title: "Scalable<br/> Architecture",
    description:
      "Design custom, flexible web architectures to support business growth and evolving needs. Get an adaptive, expansible product that’s future-ready.",
  },
];

function Purposeweb() {
  return (
    <div className="technoloy_sec p-100" style={{ backgroundColor: "#F9F9F9" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={8}
            lg={8}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Purpose-Built <span>Web Development</span> Solutions
            </h2>
            <p>
              TekRevol, a full-scale web development company, has all the
              elements to build dynamic and progressive web products. From
              customer-facing website and internal management portal to
              e-commerce store, we ensure excellence in every project with
              high-end development and systemic project management.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <div className="technology_main web_purpose_text">
              {StackItem.map((item, index) => (
                <div className="technology_item">
                  <div className="svg_icon web_text">{item.icon}</div>
                  <h6>{HtmlParser(item.title)}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Purposeweb;
